import { render, staticRenderFns } from "./work-item-list.component.vue?vue&type=template&id=af126f2c&"
import script from "./work-item-list.component.vue?vue&type=script&lang=ts&"
export * from "./work-item-list.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports